export const userConstants = {
    ALL_REQUEST: 'user:all_request',
    ALL_SUCCESS: 'user:all_success',
    ALL_FAILURE: 'user:all_failure',
    USER_EXPERIENCES:'user:experiences',
    USER_EDUCATIONS:'user:educations',
    USER_EXPERIENCE:'user:experience',
    USER_EDUCATION:'user:education',
    USER_PUBLIC:'user:public',
    USER_CONNECTIONS:'user:connections',
    USER_FAVORITES:'user:favorites',
    USER_FAVORITE:'user:favorite',
};

